import {useEffect} from 'react'
import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'

import {Box, CircularProgress, AbsoluteCenter, Text} from '@chakra-ui/react'

import {LogoHorizontal, ThemeProvider} from '../../components'

const LoadingCustomerPaymentScreen = ({fetchUrl, paymentServiceAvailable}) => {
  const {t} = useTranslation('payments')

  useEffect(() => {
    if (paymentServiceAvailable) {
      window.location.href = fetchUrl
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ThemeProvider>
      <Box
        width="100%"
        backgroundColor="mld.neutral.800"
        minHeight="100vh"
        px="sm"
        py="lg"
      >
        <Box
          padding="lg"
          backgroundColor="neutral.white"
          maxWidth="lg"
          margin="0 auto"
          borderRadius="lg"
          boxShadow="0px 2px 4px rgba(23, 27, 30, 0.1)"
        >
          <LogoHorizontal width={295} height={34} />

          <Box position="relative" h="200px">
            {paymentServiceAvailable ? (
              <AbsoluteCenter p="4" color="white" axis="both">
                <CircularProgress
                  isIndeterminate
                  value={30}
                  color="orange"
                  thickness="12px"
                  data-testid="loading"
                />
              </AbsoluteCenter>
            ) : (
              <Box paddingTop="65px">
                <Text textStyle="body-intro-medium">
                  {t(
                    'loadingCustomerPaymentScreen.paymentServiceUnavailable.title',
                  )}
                </Text>
                <Text>
                  {t(
                    'loadingCustomerPaymentScreen.paymentServiceUnavailable.contact',
                  )}
                </Text>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  )
}

LoadingCustomerPaymentScreen.propTypes = {
  fetchUrl: PropTypes.string.isRequired,
  paymentServiceAvailable: PropTypes.bool.isRequired,
}

export default LoadingCustomerPaymentScreen
